import {Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ClaimDto} from "../../auto-generated-server-dtos/claim/claim-dto";
import {GetClaimService} from "../../claim/services/get-claim.service";
import {SubmitClaimService} from "../../claim/services/submit-claim.service";
import {Subject, take} from "rxjs";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {SubmitModalComponent} from "./submit-modal/submit-modal.component";
import {environment} from "../../../environments/environment";
import {RepairDto} from "../../auto-generated-server-dtos/claim/repairs/repair-dto";
import {OidcSecurityService} from "angular-auth-oidc-client";

@Component({
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.css']
})
export class ClaimComponent implements OnInit {

  loading = false;
  claimDto: ClaimDto|null = null;
  repairTotal = 0;
  hst = 0;
  pst = 0;
  gst = 0;
  subTotal = 0;
  total = 0;
  isSubmitted = false;
  claimId: number = 0;
  busySubmitting = false;
  protected readonly environment = environment;
  protected readonly Date = Date;
  repairTotalUpdatedSubject: Subject<number> = new Subject();
  repairs: RepairDto[] = [];
  claimExpired = false;
  claimAuthorized = false;
  repairsUpdatedSubject: Subject<RepairDto[]> = new Subject();
  submitted = new Subject<void>();

  @ViewChild('priceTotals')
  priceTotals!: ElementRef;

  @ViewChild('stickyTotals')
  stickyTotals!: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private claimService: GetClaimService,
    private submitClaimService: SubmitClaimService,
    private ngbModal: NgbModal,
    private oidcSecurityService: OidcSecurityService
  ) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.route.params.subscribe(params => {
      this.claimId = parseInt(params['claimId']);
      this.oidcSecurityService.getUserData().subscribe(userData => {
        if (!userData || userData.UserType === 'GlobalWarrantyEmployee') {
          this.router.navigate(['/adjuster/claim', this.claimId]);
        }
      });
      this.updateClaim();
    });
  }

  private updateClaim(callback?: () => void) {
    return this.claimService.GetClaim(this.claimId).subscribe(claimDto => {
      this.claimDto = claimDto;
      this.loading = false;
      this.isSubmitted = this.claimDto!.isSubmitted;
      this.claimExpired = new Date(claimDto.warranty.expiryDate!) < new Date();
      this.claimAuthorized = !!claimDto?.authorizationNumber && ["pre-approved", "accepted", "approved"].includes(claimDto.status.toLowerCase());
      if(callback) callback();
    });
  }

  openClaimSubmitModal() {
    const modalRef = this.ngbModal.open(SubmitModalComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.claimDto = this.claimDto;
    modalRef.componentInstance.Repairs = this.repairs;
  }

  submitClaim() {
    this.busySubmitting = true;
    this.submitClaimService.submitClaim(this.claimDto!.claimId).subscribe({
      next: () => {
        this.updateClaim(() => {
          this.submitted.next();
          this.repairsUpdatedSubject.pipe(take(1)).subscribe(() => this.openClaimSubmitModal());
        });
      },
      complete: () => {
        this.busySubmitting = false;
      }
    });
  }

  setRepairTotal(repairTotal: number) {
    this.repairTotal = repairTotal;
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    const boundingRectPriceTotals = this.priceTotals.nativeElement.getBoundingClientRect();
    const stickyTotalHeight = this.stickyTotals.nativeElement.querySelector('div').offsetHeight + 10;

    if (boundingRectPriceTotals.bottom <= 68) {  // top navbar always has 68px height
      this.stickyTotals.nativeElement.querySelector('div').style.top = '68px';
    } else {
      this.stickyTotals.nativeElement.querySelector('div').style.top = (68 - stickyTotalHeight) + 'px';
    }
  }

  updateRepairs($event: RepairDto[]) {
    this.repairs = $event;
    this.repairsUpdatedSubject.next($event);
  }
}
